import { AuthStatus } from '@core/auth/auth.model';
import { createAction, props } from '@ngrx/store';

export const authLogin = createAction('[Auth] Login');
export const authLogout = createAction('[Auth] Logout');
export const authLogoutSuccess = createAction('[Auth] Logout success');
export const authLogoutFailed = createAction('[Auth] Logout failed');
export const authCheck = createAction('[Auth] Check');
export const authCheckMock = createAction('[Auth] Check mock');
export const authCheckSuccess = createAction('[Auth] Check success', props<AuthStatus>());
